import { render, staticRenderFns } from "./Envelopes.vue?vue&type=template&id=fc0474c4&"
import script from "./Envelopes.vue?vue&type=script&lang=js&"
export * from "./Envelopes.vue?vue&type=script&lang=js&"
import style0 from "./Envelopes.vue?vue&type=style&index=0&id=fc0474c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports